import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  CSelect
} from '@coreui/react'
import Card from "../../components/Card";
import { Colors } from "../../constants/Colors";
import { useAppContext } from "../../context/AppContext";
import { apiRequest } from "../../services/api-request";
import { useNavigate } from "react-router-dom";
import {
  ConvertToEpoch,
  ConvertToEpochAndAddOneDay,
  FormatDatePickerSelect,
} from "../../utilities/date-utility";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./dateStyles.css";

import "../bank-css/responsive.css";
import "../bank-css/style.css";
import "../bank-css/variables.css";

const Dashboard = () => {
  const { user = {} } = useAppContext();
  const { role } = user || {};
  const currentRole = user?.role?.code || null;
  const branch_id = user?.role?.branch_id || null;

  const [dateRange, setDateRange] = useState([null, null]);

  const [startDate, endDate] = dateRange;

  const [counterDetails, setCounterDetails] = useState({});

  const navigate = useNavigate();

  const [statistics, setStatistics] = useState({total_farmers:0, total_reports:0, total_branches:0, total_loan_value:0});
  const [chartData, setChartData] = useState([]);

  const [filters, setFilters] = useState({
        state_id: "",
        circle_id: "",
        regional_id: "",
        branch_id: "",
    });

    const [statesList, setStatesList] = useState([]);
    const [circleList, setCircleList] = useState([]);
    const [regionalList, setRegionalList] = useState([]);
    const [branchList, setBranchList] = useState([]);

    useEffect(() => {
        getStates();
    }, []);

    const getStates = () => {
        apiRequest({
          url: `master/states`,
          method: "GET",
        })
        .then((res) => {
            setStatesList(res?.data);
        })
          .catch((err) => {
            alert(err?.response?.data?.message, "error");
        });
    };

    useEffect(() => {
        if (filters.state_id) {
            getCirlces(filters.state_id);
        }
    }, [filters.state_id]);

    const getCirlces = (state_id) => {
        apiRequest({
          url: "bank/get-circle-office?state_id="+state_id,
          method: "GET",
        })
        .then((res) => {
            setCircleList(res?.data);
            setFilters(prev => ({
                ...prev,
                circle_id: "",
                regional_id: "",
                branch_id: "",
            }));
        })
        .catch((err) => {
            alert(err?.response?.data?.message, "error");
        });
    };

    useEffect(() => {
        if (filters.circle_id) {
          getRegionals(filters.circle_id);
        }
    }, [filters.circle_id]);

    const getRegionals = (circle_id) => {
        apiRequest({
          url: "bank/get-regional-office?circle_id="+circle_id,
          method: "GET",
        })
        .then((res) => {
            setRegionalList(res?.data);
            setFilters(prev => ({
                ...prev,
                regional_id: "",
                branch_id: "",
            }));
        })
        .catch((err) => {
            alert(err?.response?.data?.message, "error");
        });
    };

    useEffect(() => {
        if (filters.regional_id) {
          getBranches(filters.regional_id);
        }
    }, [filters.regional_id]);

    const getBranches = (regional_id) => {
        apiRequest({
          url: "bank/get-branch?regional_id="+regional_id,
          method: "GET",
        })
        .then((res) => {
            setBranchList(res?.data);
            setFilters(prev => ({
                ...prev,
                branch_id: ""
            }));
        })
        .catch((err) => {
            alert(err?.response?.data?.message, "error");
        });
    };

    const getStatistics = (appliedFilters = {}) => {
        appliedFilters.currentRole = currentRole
        appliedFilters.branch_id = branch_id
        apiRequest({
            url: "bank/get-dashboard-report-statistics",
            method: "POST",
            data: appliedFilters,
        })
        .then((res) => {
            setStatistics(res.data);
            setChartData(res.data.breedsArr || []);
        })
        .catch((err) => {
            console.log(err);
        });
    };

    useEffect(() => {
        const payload = Object.fromEntries(
            Object.entries(filters).filter(([_, v]) => v)
        );
        getStatistics(payload);
    }, [filters]);

    const handleChangeFilter = (field) => (e) => {
        const value = e.target.value;
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleChange = (update) => {
      if (update?.length) {
        let payload = Object.fromEntries(
            Object.entries(filters).filter(([_, v]) => v)
        );
        

        setDateRange(update);
        const [startDate, endDate] = update;
        const startDateLocal = new Date(startDate);
        const endDateLocal = new Date(endDate);
        const startDateString = FormatDatePickerSelect(startDateLocal);
        const endDateString = FormatDatePickerSelect(endDateLocal);
        const fromDate = ConvertToEpoch(startDateString);
        const toDate = ConvertToEpochAndAddOneDay(endDateString);

        if (fromDate && toDate) {
          payload.fromDate = fromDate
          payload.toDate = toDate
          getStatistics(payload);
        } else {
          getStatistics(payload);
        }
      }
    };  

    const total = chartData.reduce(
      (sum, item) => sum + Number(item.count || 0),
      0
    );
    let currentPercent = 0;

    const gradient =
    total === 0
      ? "#eee 0% 100%"
      : chartData
          .map((item) => {
            const start = currentPercent;
            const percent = (item.count / total) * 100;
            currentPercent += percent;
            return `${item.color} ${start}% ${currentPercent}%`;
          })
          .join(", ");


  const getDashboardCounters = () => {
    let payload = {
      currentRole,
      branch_id
    };
    let url = `bank/dashboard-count-b2b-admin`
    apiRequest({
      url,
      data: payload,
      method: "POST",
    })
      .then((res) => {
        setCounterDetails(res.data);
      })
      .catch((err) => {
        console.log(err)
        //alert(err);
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getDashboardCounters();
  }, []);

  const DashboardCards = (props) => {
    const { title, image, cardValue, incrementValue, totalOrders } = props;
    return (
      <Card>
        <Grid container onClick={props.onClick} justifyContent={"center"} alignItems={"center"} gap={4}>
          <Grid item>
            <Typography
              fontFamily={"Poppins-Regular"}
              fontSize={13}
              color={Colors.textColor}
            >
              {title}
            </Typography>
            {totalOrders ? (
              <>
                <Box
                  mt={"10px"}
                  mb={2}
                  display={"flex"}
                  gap={"15px"}
                  alignItems={"center"}
                >
                  <Typography
                    onClick={() => navigate(`/request/buy`)}
                    fontFamily={"Poppins-Medium"}
                    fontSize={14}
                    color={Colors.textColor}
                    sx={{ cursor: "pointer" }}
                  >
                    <b>Sell :</b> {props.sellValue}
                  </Typography>
                  <Typography
                    sx={{ cursor: "pointer" }}
                    onClick={() => navigate("/request/sell")}
                    fontFamily={"Poppins-Medium"}
                    fontSize={14}
                    color={Colors.textColor}
                  >
                    <b>Buy :</b> {props.buyValue}
                  </Typography>
                </Box>
              </>
            ) : (
              <Typography
                fontFamily={"Poppins-Medium"}
                fontSize={18}
                color={Colors.textColor}
                mt={1}
                mb={2}
              >
                {cardValue}
              </Typography>
            )}

            <Grid
              container
              justifyContent={"center"}
              alignItems={"center"}
              gap={0.5}
            >
              <Grid item>
                <Box
                  width={41}
                  height={14}
                  backgroundColor={Colors.lightGreen}
                  borderRadius={1}
                >
                  <Typography
                    fontFamily={"Poppins-Regular"}
                    fontSize={9}
                    color={Colors.lightGreen1}
                    textAlign={"center"}
                  >
                    + {incrementValue}
                  </Typography>
                </Box>
              </Grid>
              {/* {Boolean(incrementValue) && ( */}
              <Grid item>
                <Typography
                  fontFamily={"Poppins-Regular"}
                  fontSize={9}
                  color={Colors.textColor}
                >
                  Since Last week
                </Typography>
              </Grid>
              {/* )} */}
            </Grid>
          </Grid>
          <Grid item onClick={props.onClick} sx={{ cursor: "pointer" }}>
            <Box
              width={50}
              height={50}
              borderRadius={25}
              border={2}
              borderColor={Colors.headerColor}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <img src={image} style={styles.dashboardImage} alt="bug" />
            </Box>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const renderb2bDashboard = () => (
    <>
      {/* Mithun admin Cards starts here */}
      <Grid container mt={2} justifyContent={"center"} alignItems={"center"}>
        {
          currentRole !== 'branchManager' ?
          <Grid item md={3}>
            <DashboardCards
              title={"Total Loan Officers"}
              image={require("../../assets/sidebar/loan-officer.png")}
              cardValue={counterDetails?.total_loan_officers}
              incrementValue={counterDetails?.total_loan_officers}
              onClick={
                currentRole !== 'branchManager'
                  ? () => navigate('/loan-officers')
                  : undefined
              }
            />
          </Grid> :
          <Grid item md={3}>
            <div
              style={{
                background: '#ffffff',
                borderRadius: '12px',
                padding: '20px',
                //height: '140px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              <div
                style={{
                  fontSize: '14px',
                  color: '#6b7280',
                  marginBottom: '8px'
                }}
              >
                Branch Manager
              </div>

              <div
                style={{
                  fontSize: '18px',
                  fontWeight: 600,
                  color: '#111827'
                }}
              >
                {user?.role?.branch_manager_name}
              </div>

              <div
                style={{
                  marginTop: '6px',
                  fontSize: '14px',
                  color: '#374151'
                }}
              >
                Branch Code: <strong>{user?.role?.branch_code}</strong>
              </div>
            </div>
          </Grid>
        }
        <Grid item md={3}>
          <DashboardCards
            title={"Total Veterinary"}
            image={require("../../assets/sidebar/veterinary.png")}
            cardValue={counterDetails?.total_veterinaries}
            incrementValue={counterDetails?.total_veterinaries}
            onClick={
              currentRole !== 'branchManager'
                ? () => navigate('/veterinaries')
                : undefined
            }
          />
        </Grid>
        <Grid item md={3}>
          <DashboardCards
            title={"Total Customers"}
            image={require("../../assets/sidebar/customer.png")}
            cardValue={counterDetails?.total_farmers}
            incrementValue={counterDetails?.total_farmers}
            onClick={() => navigate(`/b2bfarmer`)}
          />
        </Grid>
        <Grid item md={3}>
          <DashboardCards
            title={"Total Animals"}
            image={require("../../assets/sidebar/animal.png")}
            cardValue={counterDetails?.total_animals}
            incrementValue={counterDetails?.total_animals}
            onClick={() => navigate(`/b2banimal`)}
          />
        </Grid>
      </Grid>
    </>
  );

  const [isMapOpen, setIsMapOpen] = useState(false);

  return (
    <Box>
      <Grid container justifyContent={"space-between"} alignItems={"center"}>
        <Grid item>
          <Typography
            fontFamily={"Poppins-Medium"}
            fontSize={20}
            color={Colors.textColor}
          >
            Dashboard
          </Typography>
        </Grid>
      </Grid>

      <>
          {
            renderb2bDashboard()
          }
          <div>
            <div className="dashboard-section">
                {
                  currentRole !== 'branchManager' ?
                  <div className="filters-wrapper">
                      <div className="filter-input-wrapper">
                        <label className="filter-input-label">State</label>
                        <CSelect custom onChange={handleChangeFilter('state_id')} value={filters.state_id} className="filter-input">
                            <option value="">--Select State--</option>
                            {
                                statesList.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.display_name}</option>;
                                })
                            }
                        </CSelect>
                    </div>
                    <div className="filter-input-wrapper">
                        <label className="filter-input-label">Circle</label>
                        <CSelect custom onChange={handleChangeFilter('circle_id')} value={filters.circle_id} className="filter-input">
                            <option value="">--Select Circle--</option>
                            {
                                circleList.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.name}</option>;
                                })
                            }
                        </CSelect>
                    </div>
                    <div className="filter-input-wrapper">
                        <label className="filter-input-label">Regional Office</label>
                        <CSelect custom onChange={handleChangeFilter('regional_id')} value={filters.regional_id} className="filter-input">
                            <option value="">--Select Regional--</option>
                            {
                                regionalList.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.name}</option>;
                                })
                            }
                        </CSelect>
                    </div>
                    <div className="filter-input-wrapper">
                        <label className="filter-input-label">Branch</label>
                        <CSelect custom onChange={handleChangeFilter('branch_id')} value={filters.branch_id} className="filter-input">
                            <option value="">--Select Branch--</option>
                            {
                                branchList.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.name} ({e.code})</option>;
                                })
                            }
                        </CSelect>
                    </div>
                  </div> : null
                }

                <section className="branch-loans-section" style={{marginTop:'10px'}}>
                    <div className="section-header">
                        <h2 className="section-title-medium">Selected Branch Loans</h2>
                        <div className="section-actions">
                            {/*<button className="btn-view-map" onClick={() => setIsMapOpen(true)}>VIEW MAP</button>*/}
                            {/*<select className="date-range-input">
                                <option>Date Range</option>
                            </select>*/}
                          <DatePicker
                            onChange={handleChange}
                            selectsRange={true}
                            isClearable={true}
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="Select Date Range"
                            className="datePickerReactPackage"
                          />
                        </div>
                    </div>

                    <div className="grid grid-3">
                        <div className="dashboard-card pink">
                            <div className="card-label">Total Customers</div>
                            <div className="card-value">{statistics.total_farmers}</div>
                        </div>
                        <div className="dashboard-card yellow">
                            <div className="card-label">Total Reports</div>
                            <div className="card-value">{statistics.total_reports}</div>
                        </div>
                        {/*<div className="dashboard-card blue">
                            <div className="card-label">Total Animals Vet Certified</div>
                            <div className="card-value">100</div>
                        </div>*/}
                        <div className="dashboard-card green">
                            <div className="card-label">Total Loan Value</div>
                            <div className="card-value">Rs. {statistics.total_loan_value}</div>
                        </div>
                    </div>
                </section>

                <section className="animal-category-section">
                    <div className="animal-progress-wrapper">
                        <h2 className="section-title-medium animal-category-title">Animal Category</h2>
                        <div className="animal-progress-items-container">
                            <div className="animal-progress-item">
                                <div className="animal-progress-bar cow">
                                    <div className="animal-progress-fill cow">
                                        <span className="animal-label">COW</span>
                                    </div>
                                    <div className="animal-progress-header">
                                        <span className="animal-count">{statistics.total_cows}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="animal-progress-item">
                                <div className="animal-progress-bar buffalo">
                                    <div className="animal-progress-fill buffalo">
                                        <span className="animal-label">BUFFALO</span>
                                    </div>
                                    <div className="animal-progress-header">
                                        <span className="animal-count">{statistics.total_buffalows}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section style={{ marginTop: "var(--spacing-2xl)" }}>
                    <div className="grid grid-2" style={{ gap: "var(--spacing-xl)" }}>
                        <div className="district-zone-section">
                            <div className="section-header">
                                <h2>Selected Zone</h2>
                            </div>
                            <div className="district-zone-cards">
                                <div className="grid grid-3 district-zone-row-1">
                                    <div className="dashboard-card yellow">
                                        <div className="card-label">No. of Branch's</div>
                                        <div className="card-value">{statistics.total_branches}</div>
                                    </div>
                                    <div className="dashboard-card pink">
                                        <div className="card-label">Total Applicants</div>
                                        <div className="card-value">{statistics.total_farmers}</div>
                                    </div>
                                    <div className="dashboard-card yellow">
                                        <div className="card-label">Total Reports</div>
                                        <div className="card-value">{statistics.total_reports}</div>
                                    </div>
                                </div>
                                <div className="grid grid-2 district-zone-row-2">
                                    {/*<div className="dashboard-card blue">
                                        <div className="card-label">Total Animals Vet Certified</div>
                                        <div className="card-value">100</div>
                                    </div>*/}
                                    <div className="dashboard-card green">
                                        <div className="card-label">Total Loan Value</div>
                                        <div className="card-value">Rs. {statistics.total_loan_value}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="breed-wise-section">
                            <div className="section-header">
                                <h2>Breed wise Sale</h2>
                                <div className="chart-filters">
                                    {/*<select className="filter-dropdown">
                                        <option>Category</option>
                                    </select>*/}
                                    {/*<select className="filter-dropdown">
                                        <option>Date</option>
                                    </select>*/}
                                </div>
                            </div>
                            <div className="chart-container">
                                <div className="chart-wrapper">
                                    <div
                                      className="donut-chart"
                                      // style={{
                                      //   background: `conic-gradient(
                                      //     #59981A 0% 37.5%,
                                      //     #F4BE37 37.5% 65%,
                                      //     #5388D8 65% 87%,
                                      //     #FF9F40 87% 100%
                                      //   )`
                                      // }}
                                      style={{
                                        background: `conic-gradient(${gradient})`,
                                      }}
                                    ></div>
                                </div>
                                <div className="chart-legend">
                                    {chartData.map((item, index) => (
                                      <div className="legend-item" key={index}>
                                        <div
                                          className="legend-dot"
                                          style={{ backgroundColor: item.color }}
                                        />
                                        <span>
                                          {item.name} (Rs. {item.display_count})
                                        </span>
                                      </div>
                                    ))}
                                    {/*<div className="legend-item">
                                        <div className="legend-dot yellow"></div>
                                        <span>Barbari</span>
                                    </div>
                                    <div className="legend-item">
                                        <div className="legend-dot dark-blue"></div>
                                        <span>Rathi</span>
                                    </div>
                                    <div className="legend-item">
                                        <div className="legend-dot blue"></div>
                                        <span>Sahiwal</span>
                                    </div>
                                    <div className="legend-item">
                                        <div className="legend-dot orange"></div>
                                        <span>Ongole</span>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
          </div>

          {/* Map Modal */}
          {isMapOpen && (
            <div className="map-modal" onClick={() => setIsMapOpen(false)}>
              sdfsdfsdfsdf
            </div>
          )}

        </>
      
    </Box>
  );
};

export default Dashboard;

const styles = {
  dashboardImage: {
    width: 30,
    height: 30,
  },
};
